import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { useSharedTrackers } from '../../common/cookies/useSharedTrackers'
import { ShadowButton } from '../../common/style/components/button'
import { Image } from '../../common/style/components/image'
import { Section } from '../../common/style/Section'
import { SectionTitle, SmallParagraph } from '../../common/typography'
import { DialogVideo } from './dialog-video'
import illustration from './resources/illustration-lalilo.svg'
import playIcon from './resources/play-triangle.svg'

export const HOW_DOES_IT_WORK_SECTION_NAME = 'how-does-it-work'

export const HowDoesItWork = () => {
  const { trackers } = useSharedTrackers()
  const [dialogVideoVisible, setDialogVideoVisible] = useState(false)
  const [t] = useTranslation('how_it_works')

  return (
    <StyledSection id={HOW_DOES_IT_WORK_SECTION_NAME}>
      <StyledImage src={illustration} />

      <SectionTitle> {t('title')} </SectionTitle>
      <Description> {t('description')} </Description>

      <PlayVideo
        onClick={() => {
          trackers.event({
            category: 'more info',
            action: 'click',
            label: 'play video',
          })
          setDialogVideoVisible(true)
        }}
      >
        <PlayIcon src={playIcon} alt="play" />
        <PlayText>{t('button')}</PlayText>
      </PlayVideo>

      <DialogVideo
        visible={dialogVideoVisible}
        videoId={t('home_video_id')}
        setDialogVideoVisible={setDialogVideoVisible}
      />
    </StyledSection>
  )
}

const StyledSection = styled(Section)`
  margin: 30px 0;
`

const StyledImage = styled(Image)`
  width: 252px;
`

const Description = styled(SmallParagraph)`
  margin-top: 20px;
  max-width: 530px;
`

const PlayVideo = styled(ShadowButton)`
  margin-top: 40px;
  padding: 0 22px;
`

const PlayIcon = styled(Image)`
  margin-right: 10px;
  vertical-align: middle;
`
const PlayText = styled.span`
  vertical-align: bottom;
  letter-spacing: 0.03em;
`
